import { Typography } from "@mui/material";
import GroupTelemetry from "features/charts/grafana/GroupTelemetry";
import { useMemo } from "react";
import { useRecordContext } from "react-admin";

const RteCommunicationGraphVisualizations = () => {
  const group = useRecordContext();

  const shouldShowTelemetry = group && group.name;

  const edrParams = useMemo(
    () =>
      group
        ? {
            "var-edr_name": group.name,
            "var-code_tm": group.code_tm,
          }
        : {
            "var-edr_name": "",
            "var-code_tm": "",
          },
    [group],
  );

  if (!shouldShowTelemetry) {
    return (
      <Typography variant="h6" align="center">
        No data to display
      </Typography>
    );
  }

  return <GroupTelemetry edrParams={edrParams} />;
};

export default RteCommunicationGraphVisualizations;
